import { render, staticRenderFns } from "./NotificacionesUsuarios.vue?vue&type=template&id=abfb2888&scoped=true&"
import script from "./NotificacionesUsuarios.vue?vue&type=script&lang=js&"
export * from "./NotificacionesUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./NotificacionesUsuarios.vue?vue&type=style&index=0&id=abfb2888&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfb2888",
  null
  
)

export default component.exports